
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Occupation } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class OccupationEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    occupation: Occupation;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getOccupation()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getOccupation(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('occupation/' + this.routeParams.id).subscribe((res: Occupation ) => {
                    this.occupation = res;
                    this.onDataChanged.next(this.occupation);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(occupation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('occupation/', occupation).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(occupation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('occupation/', occupation).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(occupation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('occupation/' + occupation.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
